module.exports = __webpack_public_path__ + "img/arow.75bbebe9.svg";